import React, { useState } from "react";
import { graphql, useStaticQuery } from "gatsby";

// Components //
import TitleSection from "../../molecules/title-section";
import RichtextDescription from "../../atoms/richtext-description/richtextDescription";

// Styles //
import "./frequent-questions.scss";

const FrequentlyAskedQuestions = (props: any) => {

    const {
        tituloGeneral,
        referenciaPlantillaContenido: CategoryList,
    } = props;


    const FrequentQuestionInfo = () => {
        const [showAnswers, setShowAnswers] = useState(-1);
        const [showQuestions, setShowQuestions] = useState(-1);

        const changeanswers = (dess: number) => {
            setShowAnswers(showAnswers === dess ? -1 : dess);
        };

        const changeCategory = (dess: number) => {
            setShowQuestions(showQuestions === dess ? -1 : dess);
        };

        return (
            <>
                {CategoryList.map((category, i) => (
                    <div className={`o-questions`} key={i}>
                        <h3
                            className={`o-questions-title ${
                                i === showQuestions
                                    ? "o-questions-title-show"
                                    : ""
                            } `}
                            onClick={() => changeCategory(i)}
                        >
                            <span>{category.tituloBanner}</span>
                            <i
                                className={`o-questions-icon ${
                                    i === showQuestions
                                        ? "icon-minus-thin"
                                        : "icon-plus-thin"
                                }`}
                            />
                        </h3>

                        <div className={`o-questions-description`}>
                            {category.referenciaContenido?.map((question, j) => (
                                <div className={`o-questions`} key={i + j}>
                                    <h3
                                        className={`o-questions-title inner ${
                                            i + j === showAnswers
                                                ? "o-questions-title-show"
                                                : ""
                                        } `}
                                        onClick={() => changeanswers(i + j)}
                                    >
                                        <span>{question.tituloBanner}</span>
                                        <i
                                            className={`o-questions-icon ${
                                                i + j === showAnswers
                                                    ? "icon-minus-thin"
                                                    : "icon-plus-thin"
                                            }`}
                                        />
                                    </h3>
                                    <div className={`o-questions-description`}>
                                        {
                                            <RichtextDescription
                                                {...question.descripcion}
                                            />
                                        }
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </>
        );
    };

    return (
        <div className="o-frequently">
            <TitleSection title={tituloGeneral} />
            <div className="o-frequently-questions">
                <FrequentQuestionInfo />
            </div>
        </div>
    );
};
export default FrequentlyAskedQuestions;
